import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import SectionAds from "./SectionAds";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import SectionMagazine5 from "./SectionMagazine5";
import SectionLatestPosts from "./SectionLatestPosts";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { AppDispatch, RootState } from "redux/store";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getBlog } from "redux/reducers/Properties/PropertiesSlice";

//

const BlogPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [blogs, setblogs] = useState<
    any[]
  >([]);
  const {
    blog
  } = useSelector((state: RootState) => state.property);

  useEffect(() => {
    dispatch(getBlog());
  }, [getBlog]);

  useEffect(() => {
    if (Array.isArray(blog)) {
      setblogs(blog);
    }
  }, [blog]);
  return (
    <div className="nc-BlogPage overflow-hidden relative">
      <Helmet>
        <title>Blog || Booking React Template</title>
      </Helmet>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />
      {/* ======== ALL SECTIONS ======== */}
      {/* ======= START CONTAINER ============= */}
      <div className="container relative">
        {/* === SECTION 1 === */}
        {
          blogs?.length > 0 ? (
            <div className="pt-12 pb-16 lg:pb-28">
              <SectionMagazine5 blog={blogs} />
            </div>
          ) : (
            <div className="mt-10 text-center p-10">
              <h2 className="font-medium text-4xl md:text-5xl xl:text-5xl leading-[110%]">No Blogs Found</h2>
            </div>
          )
        }



        {/* === SECTION 1 === */}
        {/* <SectionAds /> */}

        {/* === SECTION 8 === */}
        {/* <SectionLatestPosts className="py-16 lg:py-28" /> */}

        {/* === SECTION 1 === */}
        <SectionSubscribe2 className="pb-16 lg:pb-28" />
      </div>
    </div>
  );
};

export default BlogPage;
